<ng-template #VerifEmailPopup let-modal>
    <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
        <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body advanced-settings">
        <div class="content">
            <div class="content__title">Verify</div>
            <div class="content__box verify-content-shepherd">
                <label class="input">
                    <input class="input__field" type="email" placeholder=" " [(ngModel)]="email"
                        [disabled]="savedEmail" />
                    <span class="input__label">Email</span>
                </label>
                <button *ngIf="!this.user?.email" class="btn btn-secondary mb-2" [disabled]="savedEmail"
                    (click)="saveProfileInfo()"><i class="fa fa-envelope"></i> Verify Email</button>

                <div *ngIf="savedEmail" class="content__box verify-content-shepherd">
                    <label class="input">
                        <input class="input__field" type="text" placeholder=" " pattern="\d*" maxlength="6"
                            [(ngModel)]="selectedOTP" />
                        <span class="input__label">OTP</span>
                    </label>
                    <button class="btn btn-secondary mb-2" (click)="verifyEmailOtp()">
                        <i class="fa fa-check-circle"></i>
                        Verify
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>